import { useMutation } from '@tanstack/react-query';

import get from 'lodash/get';

import { useSnackBar } from '@sbv-clients/ui-shared';

import {
  useApi,
  Api,
  AccountApiAccountV2PhoneNumberSendOtpPostRequest,
} from '../index';

const sendOtp =
  (api: Api) =>
  ({ phoneNumber }: AccountApiAccountV2PhoneNumberSendOtpPostRequest) => {
    return api.accountApi.accountV2PhoneNumberSendOtpPost({
      phoneNumber,
    });
  };

export const useSendOtp = () => {
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(sendOtp(api), {
    onError: async (error) => {
      const message =
        get(error, 'response.data', '') || get(error, 'message', '');
      notifyError(message);
    },
  });
};
